import { render, staticRenderFns } from "./BlockMenuItem.vue?vue&type=template&id=1bbdb29c&scoped=true"
import script from "./BlockMenuItem.vue?vue&type=script&lang=js"
export * from "./BlockMenuItem.vue?vue&type=script&lang=js"
import style0 from "./BlockMenuItem.vue?vue&type=style&index=0&id=1bbdb29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdb29c",
  null
  
)

export default component.exports